<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="pageItemList">
    <page-header :title="$t('coefficientReadinessReport')">
      <template slot="actions">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="cyan darken-1"
              dark
              @click="refreshCoefficientReadiness()"
              v-on="on"
            >
              {{ $t("refreshCoefficient") }}
            </v-btn>
          </template>
          <span>{{ $t("refreshCoefficientReadinessTooltip") }}</span>
        </v-tooltip>
      </template>
    </page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <coefficient-readiness-yearly
            ref="coeAvaY"
          ></coefficient-readiness-yearly>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  UPDATE_COEFFICIENT_READINESS,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import CoefficientReadinessYearly from "./Component/CoefficientReadinessYearly.vue";

export default {
  components: {
    "coefficient-readiness-yearly": CoefficientReadinessYearly
  },
  data() {
    return {
      tab: "tab-1"
    };
  },
  mixins: [refreshButtonMixin],
  methods: {
    refreshCoefficientReadiness() {
      this.$store.dispatch(UPDATE_COEFFICIENT_READINESS).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("refreshCoefficientReadinessSuccessfully"),
          color: "success"
        });
      });
    }
  }
};
</script>

<style scoped></style>
